import _defineProperty from "/__w/casino-eci88-v2/casino-eci88-v2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
var genDraggerStyle = function genDraggerStyle(token) {
  var _$concat2;
  var componentCls = token.componentCls,
    iconCls = token.iconCls;
  return _defineProperty({}, "".concat(componentCls, "-wrapper"), _defineProperty({}, "".concat(componentCls, "-drag"), (_$concat2 = {
    position: 'relative',
    width: '100%',
    height: '100%',
    textAlign: 'center',
    background: token.colorFillAlter,
    border: "".concat(token.lineWidth, "px dashed ").concat(token.colorBorder),
    borderRadius: token.borderRadiusLG,
    cursor: 'pointer',
    transition: "border-color ".concat(token.motionDurationSlow)
  }, _defineProperty(_$concat2, componentCls, {
    padding: "".concat(token.padding, "px 0")
  }), _defineProperty(_$concat2, "".concat(componentCls, "-btn"), {
    display: 'table',
    width: '100%',
    height: '100%',
    outline: 'none'
  }), _defineProperty(_$concat2, "".concat(componentCls, "-drag-container"), {
    display: 'table-cell',
    verticalAlign: 'middle'
  }), _defineProperty(_$concat2, "&:not(".concat(componentCls, "-disabled):hover"), {
    borderColor: token.colorPrimaryHover
  }), _defineProperty(_$concat2, "p".concat(componentCls, "-drag-icon"), _defineProperty({
    marginBottom: token.margin
  }, iconCls, {
    color: token.colorPrimary,
    fontSize: token.uploadThumbnailSize
  })), _defineProperty(_$concat2, "p".concat(componentCls, "-text"), {
    margin: "0 0 ".concat(token.marginXXS, "px"),
    color: token.colorTextHeading,
    fontSize: token.fontSizeLG
  }), _defineProperty(_$concat2, "p".concat(componentCls, "-hint"), {
    color: token.colorTextDescription,
    fontSize: token.fontSize
  }), _defineProperty(_$concat2, "&".concat(componentCls, "-disabled"), _defineProperty({
    cursor: 'not-allowed'
  }, "p".concat(componentCls, "-drag-icon ").concat(iconCls, ",\n            p").concat(componentCls, "-text,\n            p").concat(componentCls, "-hint\n          "), {
    color: token.colorTextDisabled
  })), _$concat2)));
};
export default genDraggerStyle;